<div class="desktop_section">
  <app-header></app-header>
  <div class="desktop_body">
    <router-outlet (activate)="onActivate()"></router-outlet>
  </div>
</div>
